var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMetroBuilding(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 347,
    height: 215,
    viewBox: "0 0 347 215",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M217.023 28.2118H129.612V4.75565C129.612 3.05743 149.178 1.67822 173.317 1.67822C197.457 1.67822 217.023 3.05421 217.023 4.75565V28.2086V28.2118Z",
    fill: "#BDBAA9",
    stroke: "#382456",
    strokeWidth: 0.448713,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M173.148 7.39258C172.061 7.39258 170.988 7.39258 169.92 7.40225V28.2163H173.148",
    fill: "#C5ECFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M173.148 7.39258C172.061 7.39258 170.988 7.39258 169.92 7.40225V28.2163H173.148",
    stroke: "#382456",
    strokeWidth: 0.448713,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M158.249 7.57931V28.2161H163.56V7.46973C161.746 7.49873 159.969 7.53419 158.249 7.57931Z",
    fill: "#C5ECFF",
    stroke: "#382456",
    strokeWidth: 0.448713,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M147.733 7.96877V28.2124H152.061V7.77539C150.562 7.8334 149.116 7.89786 147.733 7.96877Z",
    fill: "#C5ECFF",
    stroke: "#382456",
    strokeWidth: 0.448713,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M137.503 8.69808V28.2133H141.265V8.37256C139.909 8.47569 138.652 8.58528 137.503 8.69808Z",
    fill: "#C5ECFF",
    stroke: "#382456",
    strokeWidth: 0.448713,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M173.148 6.4165C172.061 6.4165 170.989 6.4165 169.92 6.42617C169.471 6.42617 169.022 6.43262 168.573 6.43584V28.2168H169.92V7.40274C170.984 7.39629 172.061 7.39307 173.148 7.39307",
    fill: "#A67C52"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M173.148 6.4165C172.061 6.4165 170.989 6.4165 169.92 6.42617C169.471 6.42617 169.022 6.43262 168.573 6.43584V28.2168H169.92V7.40274C170.984 7.39629 172.061 7.39307 173.148 7.39307",
    stroke: "#382456",
    strokeWidth: 0.448713,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M158.249 6.6005C157.585 6.61662 156.929 6.63595 156.283 6.65529V28.2171H158.249V7.58029C159.973 7.53517 161.747 7.49971 163.56 7.47071V28.2171H164.35V6.47803C164.085 6.48125 163.821 6.48447 163.56 6.49092C161.747 6.51993 159.969 6.55538 158.249 6.6005Z",
    fill: "#A67C52",
    stroke: "#382456",
    strokeWidth: 0.448713,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M145.488 7.11615V28.217H147.737V7.97024C149.12 7.89933 150.565 7.83487 152.065 7.77686V6.80029C150.565 6.85831 149.12 6.92277 147.737 6.99367C146.969 7.03235 146.22 7.07425 145.488 7.11615Z",
    fill: "#A67C52",
    stroke: "#382456",
    strokeWidth: 0.448713,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M134.581 8.05993V28.2165H137.504V8.69808C138.653 8.58206 139.91 8.47247 141.266 8.37256V7.396C139.91 7.49913 138.653 7.60871 137.504 7.72152C136.431 7.82788 135.452 7.94068 134.581 8.05993Z",
    fill: "#A67C52",
    stroke: "#382456",
    strokeWidth: 0.448713,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M129.612 7.47997V28.2167H131.224V6.64844C130.173 6.91272 129.612 7.1899 129.612 7.47675V7.47997Z",
    fill: "#BDBAA9",
    stroke: "#382456",
    strokeWidth: 0.448713,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M141.264 8.37341V28.2142H142.997V4.37109C142.405 4.40976 141.825 4.45166 141.264 4.49677V8.37663V8.37341Z",
    fill: "#FEFDE8",
    stroke: "#382456",
    strokeWidth: 0.448713,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M131.223 9.62956V28.2104H132.09V5.55957C131.771 5.62402 131.484 5.68847 131.223 5.75292V9.63278V9.62956Z",
    fill: "#FEFDE8",
    stroke: "#382456",
    strokeWidth: 0.448713,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M152.06 7.77605V28.2098H154.241V3.81885C153.5 3.84463 152.773 3.87041 152.06 3.89941V7.77927V7.77605Z",
    fill: "#FEFDE8",
    stroke: "#382456",
    strokeWidth: 0.448713,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M164.354 3.57793V28.2105H167.433V3.54248C166.396 3.55215 165.368 3.56504 164.354 3.57793Z",
    fill: "#FEFDE8",
    stroke: "#382456",
    strokeWidth: 0.448713,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M142.997 8.24616V28.2094H145.488V4.21484C144.631 4.26318 143.8 4.31796 142.997 4.36952V8.24939V8.24616Z",
    fill: "#BDBAA9",
    stroke: "#382456",
    strokeWidth: 0.448713,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M132.09 9.43863V28.2128H134.581V5.15918C133.62 5.28808 132.785 5.42342 132.09 5.56199V9.44185V9.43863Z",
    fill: "#BDBAA9",
    stroke: "#382456",
    strokeWidth: 0.448713,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M154.241 7.69822V28.2125H156.284V3.75391C155.593 3.77324 154.915 3.7958 154.241 3.81836V7.69822Z",
    fill: "#BDBAA9",
    stroke: "#382456",
    strokeWidth: 0.448713,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M167.433 3.54141V28.2095H168.578V3.53174C168.196 3.53174 167.815 3.53818 167.433 3.54141Z",
    fill: "#BDBAA9",
    stroke: "#382456",
    strokeWidth: 0.448713,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M141.265 5.46334L142.998 5.01531L145.489 5.18292V4.21595L142.998 4.04834L141.265 4.49637V5.46334Z",
    fill: "#382456",
    stroke: "#382456",
    strokeWidth: 0.448713,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M152.06 4.86646L154.242 4.46355L156.284 4.72141V3.75444L154.242 3.49658L152.06 3.89949V4.86646Z",
    fill: "#382456",
    stroke: "#382456",
    strokeWidth: 0.448713,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M164.354 4.5435L167.434 4.33722L168.579 4.49838V3.38314L167.434 3.21875L164.354 3.42826V4.5435Z",
    fill: "#382456",
    stroke: "#382456",
    strokeWidth: 0.448713,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M131.224 6.71963L132.091 6.20378L134.583 6.1264V5.15918L132.091 5.23656L131.224 5.75241V6.71963Z",
    fill: "#382456",
    stroke: "#382456",
    strokeWidth: 0.448713,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M131.223 7.35408L129.612 7.54745V6.58058L131.223 6.38721V7.35408Z",
    fill: "#382456",
    stroke: "#382456",
    strokeWidth: 0.448713,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M173.147 7.39258C174.233 7.39258 175.306 7.39258 176.375 7.40225V28.2163H173.147",
    fill: "#C5ECFF"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M173.147 7.39258C174.233 7.39258 175.306 7.39258 176.375 7.40225V28.2163H173.147",
    stroke: "#382456",
    strokeWidth: 0.448713,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M188.05 7.57931V28.2161H182.739V7.46973C184.553 7.49873 186.331 7.53419 188.05 7.57931Z",
    fill: "#C5ECFF",
    stroke: "#382456",
    strokeWidth: 0.448713,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M198.563 7.96877V28.2124H194.235V7.77539C195.734 7.8334 197.18 7.89786 198.563 7.96877Z",
    fill: "#C5ECFF",
    stroke: "#382456",
    strokeWidth: 0.448713,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M208.796 8.69759V28.2128H205.034V8.37207C206.39 8.47521 207.647 8.58479 208.796 8.69759Z",
    fill: "#C5ECFF",
    stroke: "#382456",
    strokeWidth: 0.448713,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M173.147 6.4165C174.233 6.4165 175.306 6.4165 176.375 6.42617C176.824 6.42617 177.273 6.43262 177.722 6.43584V28.2168H176.375V7.40274C175.311 7.39629 174.233 7.39307 173.147 7.39307",
    fill: "#A67C52"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M173.147 6.4165C174.233 6.4165 175.306 6.4165 176.375 6.42617C176.824 6.42617 177.273 6.43262 177.722 6.43584V28.2168H176.375V7.40274C175.311 7.39629 174.233 7.39307 173.147 7.39307",
    stroke: "#382456",
    strokeWidth: 0.448713,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M188.05 6.6005C188.715 6.61662 189.37 6.63595 190.017 6.65529V28.2171H188.05V7.58029C186.326 7.53517 184.553 7.49971 182.739 7.47071V28.2171H181.949V6.47803C182.214 6.48125 182.479 6.48447 182.739 6.49092C184.553 6.51993 186.331 6.55538 188.05 6.6005Z",
    fill: "#A67C52",
    stroke: "#382456",
    strokeWidth: 0.448713,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M200.812 7.11615V28.217H198.562V7.97024C197.18 7.89933 195.734 7.83487 194.235 7.77686V6.80029C195.734 6.85831 197.18 6.92277 198.562 6.99367C199.33 7.03235 200.08 7.07425 200.812 7.11615Z",
    fill: "#A67C52",
    stroke: "#382456",
    strokeWidth: 0.448713,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M211.719 8.05993V28.2165H208.796V8.69808C207.647 8.58206 206.39 8.47247 205.034 8.37256V7.396C206.39 7.49913 207.647 7.60871 208.796 7.72152C209.869 7.82788 210.848 7.94068 211.719 8.05993Z",
    fill: "#A67C52",
    stroke: "#382456",
    strokeWidth: 0.448713,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M216.682 7.47948V28.2162H215.071V6.64795C216.121 6.91223 216.682 7.18941 216.682 7.47626V7.47948Z",
    fill: "#BDBAA9",
    stroke: "#382456",
    strokeWidth: 0.448713,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M205.035 8.37341V28.2142H203.302V4.37109C203.895 4.40976 204.474 4.45166 205.035 4.49677V8.37663V8.37341Z",
    fill: "#FEFDE8",
    stroke: "#382456",
    strokeWidth: 0.448713,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M215.071 9.62956V28.2104H214.205V5.55957C214.524 5.62402 214.811 5.68847 215.071 5.75292V9.63278V9.62956Z",
    fill: "#FEFDE8",
    stroke: "#382456",
    strokeWidth: 0.448713,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M194.24 7.77654V28.2103H192.058V3.81934C192.799 3.84512 193.526 3.8709 194.24 3.8999V7.77976V7.77654Z",
    fill: "#FEFDE8",
    stroke: "#382456",
    strokeWidth: 0.448713,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M181.945 3.57793V28.2105H178.866V3.54248C179.903 3.55215 180.931 3.56504 181.945 3.57793Z",
    fill: "#FEFDE8",
    stroke: "#382456",
    strokeWidth: 0.448713,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M203.302 8.24616V28.2094H200.81V4.21484C201.668 4.26318 202.498 4.31796 203.302 4.36952V8.24939V8.24616Z",
    fill: "#BDBAA9",
    stroke: "#382456",
    strokeWidth: 0.448713,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M214.205 9.43863V28.2128H211.714V5.15918C212.674 5.28808 213.509 5.42342 214.205 5.56199V9.44185V9.43863Z",
    fill: "#BDBAA9",
    stroke: "#382456",
    strokeWidth: 0.448713,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M192.053 7.69871V28.213H190.011V3.75439C190.702 3.77373 191.38 3.79629 192.053 3.81884V7.69871Z",
    fill: "#BDBAA9",
    stroke: "#382456",
    strokeWidth: 0.448713,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M178.865 3.54141V28.2095H177.721V3.53174C178.102 3.53174 178.484 3.53818 178.865 3.54141Z",
    fill: "#BDBAA9",
    stroke: "#382456",
    strokeWidth: 0.448713,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M205.035 5.46334L203.302 5.01531L200.81 5.18292V4.21595L203.302 4.04834L205.035 4.49637V5.46334Z",
    fill: "#382456",
    stroke: "#382456",
    strokeWidth: 0.448713,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M194.24 4.86646L192.054 4.46355L190.015 4.72141V3.75444L192.054 3.49658L194.24 3.89949V4.86646Z",
    fill: "#382456",
    stroke: "#382456",
    strokeWidth: 0.448713,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M181.946 4.5435L178.866 4.33722L177.721 4.49838V3.38314L178.866 3.21875L181.946 3.42826V4.5435Z",
    fill: "#382456",
    stroke: "#382456",
    strokeWidth: 0.448713,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M215.073 6.71915L214.206 6.20329L211.718 6.12591V5.15869L214.206 5.23607L215.073 5.75192V6.71915Z",
    fill: "#382456",
    stroke: "#382456",
    strokeWidth: 0.448713,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M215.071 7.35408L216.682 7.54745V6.58058L215.071 6.38721V7.35408Z",
    fill: "#382456",
    stroke: "#382456",
    strokeWidth: 0.448713,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M173.317 23.5308C161.611 23.5308 129.612 25.8735 129.612 27.5749V32.1508H217.023V27.5749C217.023 25.8767 185.024 23.5308 173.317 23.5308Z",
    fill: "#FEFDE8",
    stroke: "#382456",
    strokeWidth: 0.448713,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M217.023 3.40263C217.023 1.7044 197.457 0.325195 173.318 0.325195C149.178 0.325195 129.612 1.70118 129.612 3.40263V4.75605C129.612 3.05783 149.178 1.67862 173.318 1.67862C197.457 1.67862 217.023 3.0546 217.023 4.75605V3.40263Z",
    fill: "#FEFDE8",
    stroke: "#382456",
    strokeWidth: 0.448713,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M86.0779 35.9517L89.3591 38.7167L173.148 31.6427V28.0742L86.0779 35.9517Z",
    fill: "#FEFDE8",
    stroke: "#382456",
    strokeWidth: 0.448713,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M89.3589 38.7161V46.8181L173.148 39.7395V31.6421L89.3589 38.7161Z",
    fill: "#DA7263",
    stroke: "#382456",
    strokeWidth: 0.448713,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3196 49.8611L58.4411 54.426L173.148 45.552V39.7393L53.3196 49.8611Z",
    fill: "#FEFDE8",
    stroke: "#382456",
    strokeWidth: 0.448713,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4414 54.4262V70.9937L173.148 61.6709V45.5522L58.4414 54.4262Z",
    fill: "#DA7263",
    stroke: "#382456",
    strokeWidth: 0.448713,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4414 83.7903L173.148 70.4277V61.6704L58.4414 70.9933V83.7903Z",
    fill: "#DDDAD0",
    stroke: "#382456",
    strokeWidth: 0.448713,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M120.236 30.0215V32.7595L173.148 28.0734V25.3398L120.236 30.0215Z",
    fill: "#DA7263",
    stroke: "#382456",
    strokeWidth: 0.448713,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M118.301 28.7198L120.236 30.0215L173.148 25.3399V23.5669L118.301 28.7198Z",
    fill: "#FEFDE8",
    stroke: "#382456",
    strokeWidth: 0.448713,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M260.217 35.9517L256.94 38.7167L173.147 31.6427V28.0742L260.217 35.9517Z",
    fill: "#FEFDE8",
    stroke: "#382456",
    strokeWidth: 0.448713,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M256.94 38.7166V46.8186L173.147 39.74V31.6426L256.94 38.7166Z",
    fill: "#DA7263",
    stroke: "#382456",
    strokeWidth: 0.448713,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M292.975 49.8611L287.858 54.426L173.147 45.552V39.7393L292.975 49.8611Z",
    fill: "#FEFDE8",
    stroke: "#382456",
    strokeWidth: 0.448713,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M287.858 54.4262V70.9937L173.147 61.6709V45.5522L287.858 54.4262Z",
    fill: "#DA7263",
    stroke: "#382456",
    strokeWidth: 0.448713,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M287.858 83.7903L173.147 70.4277V61.6704L287.858 70.9933V83.7903Z",
    fill: "#DDDAD0",
    stroke: "#382456",
    strokeWidth: 0.448713,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M226.059 30.0215V32.7595L173.147 28.0734V25.3398L226.059 30.0215Z",
    fill: "#DA7263",
    stroke: "#382456",
    strokeWidth: 0.448713,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M227.998 28.7198L226.059 30.0215L173.147 25.3399V23.5669L227.998 28.7198Z",
    fill: "#FEFDE8",
    stroke: "#382456",
    strokeWidth: 0.448713,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M336.349 107.261V103.691C316.064 103.635 285.486 102.54 249.395 97.9756C182.654 89.537 184.63 69.5312 184.63 69.5312H162.305C162.305 69.5312 164.285 89.5325 97.5397 97.9756C61.0259 102.593 30.156 103.66 9.87817 103.693V107.26C29.864 107.288 60.3746 106.299 97.5352 101.782C164.316 93.6486 162.3 74.4373 162.3 74.4373H184.625C184.625 74.4373 182.609 93.6486 249.39 101.782C286.122 106.247 316.355 107.265 336.349 107.261Z",
    fill: "#FEFDE8",
    stroke: "#382456",
    strokeWidth: 0.448713,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M336.304 110.812C316.599 110.871 286.708 109.944 249.458 105.589C182.675 97.7606 184.726 79.3394 184.726 79.3394H162.413C162.413 79.3394 164.464 97.7606 97.6809 105.589C59.7936 110.019 29.5658 110.927 9.87817 110.833V114.412C29.2949 114.565 59.201 113.731 97.6809 109.4C164.499 101.881 162.413 84.2499 162.413 84.2499H184.726C184.726 84.2499 182.639 101.881 249.458 109.4C287.282 113.657 316.867 114.513 336.304 114.396V110.812Z",
    fill: "#BDBAA9",
    stroke: "#382456",
    strokeWidth: 0.448713,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M336.281 107.261C316.291 107.262 286.098 106.24 249.429 101.782C182.664 93.6483 184.68 74.437 184.68 74.437H162.361C162.361 74.437 164.377 93.6483 97.6126 101.782C60.3979 106.306 29.8562 107.291 9.87817 107.26V110.831C29.573 110.922 59.7738 110.011 97.6126 105.588C164.412 97.7598 162.361 79.3386 162.361 79.3386H184.68C184.68 79.3386 182.629 97.7598 249.429 105.588C286.707 109.946 316.572 110.895 336.281 110.836V107.261Z",
    fill: "#DDDAD0",
    stroke: "#382456",
    strokeWidth: 0.448713,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M256.689 74.2716C187.103 62.9917 194.135 36.5762 194.135 36.5762H152.906C152.906 36.5762 159.938 62.9917 90.3521 74.2716C57.9383 79.5243 23.0489 80.3133 0.465088 80.1125L6.43929 87.083C28.2454 87.0397 61.1987 85.9316 92.7752 80.8115C162.361 69.5316 157.609 46.5319 157.609 46.5319H189.437C189.437 46.5319 184.684 69.5271 254.27 80.8115C285.845 85.9313 318.796 87.0365 340.602 87.0774L346.575 80.1081C323.991 80.3087 289.105 79.5195 256.693 74.2671L256.689 74.2716Z",
    fill: "#FEFDE8",
    stroke: "#382456",
    strokeWidth: 0.448713,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M340.512 87.0751C318.705 87.0305 285.801 85.9208 254.271 80.8107C184.685 69.5308 189.437 47.1172 189.437 47.1172H157.609C157.609 47.1172 162.361 69.5263 92.7755 80.8107C61.2427 85.9238 28.337 87.0328 6.53027 87.0765L9.96882 91.8595C30.0814 91.7746 60.9085 90.6505 97.6128 86.0085C164.337 77.5699 162.361 51.9372 162.361 51.9372H184.68C184.68 51.9372 182.7 77.5699 249.429 86.0085C285.723 90.5986 316.27 91.749 336.394 91.8562L340.512 87.0751Z",
    fill: "#DDDAD0",
    stroke: "#382456",
    strokeWidth: 0.448713,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M336.304 91.857C316.169 91.7473 285.637 90.594 249.371 86.0098C182.613 77.5712 184.589 51.9385 184.589 51.9385H162.259C162.259 51.9385 164.24 77.5712 97.4778 86.0098C60.8088 90.6449 30.0028 91.7725 9.87817 91.8603V103.689C30.1622 103.654 61.0069 102.584 97.4823 97.9719C164.24 89.5333 162.264 69.5276 162.264 69.5276H184.594C184.594 69.5276 182.613 89.5288 249.375 97.9719C285.448 102.533 316.014 103.63 336.304 103.688V91.857Z",
    fill: "#FEFDE8",
    stroke: "#382456",
    strokeWidth: 0.448713,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3259 114.424V116.763L31.5926 119.201V114.168L10.3259 114.424Z",
    fill: "#6B3232",
    stroke: "#382456",
    strokeWidth: 0.448713
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M88.0559 209.32H31.5891V205.878H88.0559V209.32Z",
    fill: "#603813",
    stroke: "#382456",
    strokeWidth: 0.448713,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M150.058 209.32H114.83V205.877H150.058V209.32Z",
    fill: "#603813",
    stroke: "#382456",
    strokeWidth: 0.448713,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3562 122.286H20.3838V209.324H10.3562V122.286Z",
    fill: "#603813",
    stroke: "#382456",
    strokeWidth: 0.448713,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M84.011 127.493V142.952L79.1642 143.319V121.281L84.011 127.493Z",
    fill: "#6B3232",
    stroke: "#382456",
    strokeWidth: 0.519438
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M78.8439 209.325H84.0483V144.891L78.8439 140.821V209.325Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.603066
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M84.0106 144.781H117.086V140.496L79.2855 141.105L84.0106 144.781Z",
    fill: "#6B3232",
    stroke: "#382456",
    strokeWidth: 0.603066
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M117.016 140.167V116.354C116.432 116.354 78.7517 120.974 78.7517 120.974V140.826L117.016 140.167Z",
    fill: "#DA7263",
    stroke: "#382456",
    strokeWidth: 0.519438
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M56.8948 184.947C55.6019 184.96 54.3718 184.974 53.2136 184.987V195.613H60.5759V184.902C59.301 184.92 58.071 184.933 56.8948 184.947Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.448713
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5334 185.028C48.1373 185.042 46.9027 185.051 45.8523 185.06V195.614H53.2146V184.988C51.8903 185.001 50.6602 185.015 49.5334 185.024V185.028Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.448713
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M64.2519 184.857C62.9905 184.875 61.7604 184.889 60.5708 184.902V195.613H67.9331V184.803C66.6761 184.821 65.4506 184.839 64.2519 184.853V184.857Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.448713
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6129 184.754C70.3649 184.772 69.1349 184.79 67.9317 184.808V195.618H75.3569V184.7C74.091 184.718 72.843 184.736 71.6129 184.754Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.448713
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2141 174.402C51.9077 174.429 50.6777 174.452 49.5329 174.47V185.028C50.6597 185.019 51.8898 185.006 53.2141 184.992C54.3723 184.979 55.6024 184.966 56.8953 184.952V174.331C55.6113 174.358 54.3813 174.384 53.2141 174.407V174.402Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.448713
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8525 174.524V185.06C46.903 185.051 48.1375 185.042 49.5337 185.029V174.47C48.1869 174.493 46.9524 174.511 45.8525 174.524Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.448713
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5708 174.242C59.3004 174.273 58.0748 174.3 56.8896 174.327V184.949C58.0658 184.935 59.2959 184.922 60.5708 184.904C61.7605 184.89 62.9905 184.872 64.252 184.859V174.147C62.995 174.179 61.7649 174.21 60.5708 174.242Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.448713
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6129 184.755C72.843 184.738 74.091 184.72 75.3569 184.702V173.824C74.091 173.865 72.843 173.905 71.6129 173.941V184.755Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.448713
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9324 174.049C66.6799 174.085 65.4498 174.116 64.2512 174.147V184.859C65.4498 184.845 66.6754 184.827 67.9324 184.809C69.1355 184.791 70.3655 184.773 71.6135 184.755V173.941C70.3655 173.977 69.14 174.013 67.9324 174.049Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.448713
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M64.2519 163.491C62.9994 163.54 61.7739 163.585 60.5708 163.625V174.242C61.7649 174.215 62.9905 174.184 64.2519 174.148C65.4506 174.117 66.6806 174.081 67.9331 174.049V163.338C66.6851 163.392 65.4595 163.441 64.2519 163.491Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.448713
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M56.8948 163.747C55.6288 163.788 54.3988 163.819 53.2136 163.85V174.405C54.3808 174.382 55.6109 174.355 56.8948 174.328C58.0799 174.301 59.3055 174.274 60.5759 174.243V163.626C59.3189 163.671 58.0889 163.711 56.8948 163.747Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.448713
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5334 163.935C48.236 163.962 47.0105 163.98 45.8523 163.994V174.525C46.9476 174.512 48.1822 174.494 49.5334 174.472C50.6782 174.454 51.9082 174.431 53.2146 174.404V163.85C51.9352 163.882 50.7096 163.908 49.5334 163.935Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.448713
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6129 163.172C70.3694 163.231 69.1438 163.284 67.9317 163.338V174.05C69.1393 174.014 70.3649 173.978 71.6129 173.942C72.843 173.906 74.091 173.866 75.3569 173.825V162.993C74.0955 163.056 72.8474 163.118 71.6129 163.172Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.448713
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5337 163.937V150.312C48.2363 150.339 47.0108 150.357 45.8526 150.371V163.995C47.0063 163.982 48.2363 163.964 49.5337 163.937Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.448713
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M71.613 149.554V163.179C72.8475 163.12 74.0955 163.062 75.3569 162.999V149.375C74.0955 149.437 72.8475 149.5 71.613 149.554Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.448713
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9324 149.715C66.6844 149.769 65.4589 149.818 64.2513 149.868V163.492C65.4589 163.447 66.6844 163.393 67.9324 163.34C69.14 163.286 70.37 163.232 71.6135 163.173V149.549C70.37 149.607 69.1445 149.661 67.9324 149.715Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.448713
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2141 150.226C51.9347 150.258 50.7092 150.285 49.533 150.312V163.936C50.7047 163.914 51.9347 163.887 53.2141 163.851C54.3993 163.82 55.6293 163.788 56.8953 163.748V150.123C55.6293 150.163 54.3993 150.195 53.2141 150.226Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.448713
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5709 150.002C59.3139 150.047 58.0838 150.087 56.8897 150.123V163.748C58.0838 163.712 59.3139 163.671 60.5709 163.627C61.774 163.586 62.9995 163.541 64.252 163.492V149.867C62.9995 149.917 61.774 149.961 60.5709 150.002Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.448713
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M132.286 183.264C131.509 183.3 130.705 183.336 129.87 183.372V195.615H134.701V183.143C133.933 183.183 133.125 183.224 132.286 183.264Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.448713
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M137.116 183.004C136.357 183.049 135.554 183.098 134.701 183.143V195.614H139.531V182.838C138.795 182.896 137.987 182.95 137.116 183.004Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.448713
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M127.461 183.47C126.23 183.519 124.951 183.564 123.631 183.609V195.614H129.876V183.371C129.095 183.403 128.287 183.438 127.461 183.47Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.448713
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M141.946 182.621C141.259 182.693 140.451 182.765 139.531 182.837V195.613H144.132V182.285C143.692 182.401 142.951 182.514 141.946 182.621Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.448713
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M129.876 170.947C129.09 171.019 128.287 171.091 127.461 171.158V183.472C128.287 183.441 129.095 183.405 129.876 183.373C130.707 183.337 131.515 183.302 132.291 183.266V170.714C131.51 170.79 130.707 170.871 129.876 170.947Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.448713
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M134.701 170.463C133.929 170.548 133.116 170.634 132.286 170.719V183.271C133.125 183.23 133.933 183.19 134.701 183.149C135.549 183.105 136.357 183.06 137.116 183.01V170.176C136.348 170.275 135.545 170.369 134.701 170.463Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.448713
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M139.531 169.843C138.777 169.955 137.969 170.067 137.116 170.175V183.01C137.987 182.956 138.795 182.902 139.531 182.844C140.451 182.772 141.259 182.7 141.946 182.628V169.443C141.214 169.578 140.411 169.713 139.531 169.847V169.843Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.448713
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M127.461 171.159C126.222 171.262 124.947 171.365 123.632 171.464V183.613C124.952 183.568 126.231 183.518 127.461 183.474V171.159Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.448713
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M141.946 182.624C142.951 182.516 143.697 182.404 144.132 182.287V168.958C143.513 169.12 142.776 169.282 141.946 169.434V182.619V182.624Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.448713
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M141.946 156.175C141.178 156.35 140.37 156.525 139.531 156.696V169.849C140.411 169.719 141.214 169.584 141.946 169.445C142.776 169.288 143.513 169.131 144.132 168.969V155.641C143.441 155.82 142.709 156 141.946 156.175Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.448713
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M137.116 157.158C136.335 157.301 135.531 157.441 134.701 157.58V170.464C135.545 170.369 136.348 170.275 137.116 170.176C137.969 170.069 138.777 169.956 139.531 169.844V156.691C138.754 156.848 137.951 157.005 137.116 157.153V157.158Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.448713
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M132.286 157.966C131.496 158.087 130.692 158.209 129.871 158.325V170.949C130.701 170.873 131.505 170.796 132.286 170.715C133.116 170.63 133.929 170.549 134.701 170.46V157.576C133.916 157.706 133.112 157.836 132.286 157.962V157.966Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.448713
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M127.461 158.662C126.213 158.828 124.938 158.994 123.632 159.151V171.469C124.947 171.371 126.226 171.267 127.461 171.164C128.287 171.092 129.09 171.025 129.876 170.953V158.33C129.086 158.442 128.278 158.554 127.461 158.662Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.448713
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M127.461 145.039C126.213 145.205 124.938 145.371 123.632 145.528V159.153C124.938 158.995 126.213 158.829 127.461 158.663V145.039Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.448713
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M141.946 142.551V156.176C142.709 156.001 143.445 155.821 144.132 155.642V142.017C143.441 142.197 142.709 142.376 141.946 142.551Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.448713
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M129.876 144.702C129.086 144.815 128.278 144.927 127.461 145.035V158.659C128.278 158.551 129.086 158.439 129.876 158.327C130.698 158.21 131.501 158.089 132.291 157.968V144.343C131.501 144.464 130.698 144.586 129.876 144.702Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.448713
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M139.531 143.073C138.754 143.23 137.95 143.387 137.115 143.535V157.16C137.95 157.007 138.754 156.854 139.531 156.697C140.37 156.527 141.178 156.356 141.946 156.176V142.552C141.178 142.727 140.37 142.902 139.531 143.073Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.448713
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M134.701 143.957C133.915 144.087 133.112 144.217 132.286 144.343V157.967C133.112 157.842 133.915 157.711 134.701 157.581C135.527 157.442 136.335 157.303 137.116 157.159V143.535C136.335 143.678 135.531 143.817 134.701 143.957Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.448713
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8534 146.359V150.367C53.2821 150.282 63.7991 149.95 75.3574 149.371V125.141C65.6888 125.85 55.8452 126.263 45.8534 126.416V146.359Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.448713
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2318 123.066V195.611H45.8586V126.415C55.8503 126.262 65.6938 125.849 75.3623 125.14V121.747C64.5268 122.541 53.4758 122.967 42.2363 123.066H42.2318Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.448713
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M114.835 106.984C109.623 107.864 103.851 108.68 97.4368 109.399C94.2498 109.758 91.1258 110.09 88.0556 110.4C83.7016 110.839 79.4689 111.239 75.3573 111.594C63.2111 112.644 52.1422 113.335 42.2313 113.775C38.5192 113.937 34.9732 114.067 31.5888 114.166V205.886H78.9786V121.229C88.077 120.291 108.162 118.13 116.902 116.577L117.086 205.89H150.061V96.8799C143.059 100.412 132.075 104.075 114.835 106.993V106.984ZM75.3573 149.37V195.611H42.2313V123.066C53.4708 122.963 64.5218 122.541 75.3573 121.747V149.37ZM144.132 142.017V195.616H123.628V115.22C130.594 113.784 137.43 112.132 144.132 110.238V142.013V142.017Z",
    fill: "#DA7263",
    stroke: "#382456",
    strokeWidth: 0.448713
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3544 126.181H20.3833V117.925L10.3544 116.683V126.181Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.448713
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M124.812 145.381C132.587 144.407 139.32 143.285 144.132 142.014V111.585C137.812 113.371 131.366 114.934 124.812 116.312V145.381Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.448713
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M124.813 114.965C124.418 115.05 124.028 115.135 123.628 115.221V195.616H124.813V116.316C131.366 114.938 137.817 113.376 144.132 111.589V110.243C137.812 112.029 131.366 113.591 124.813 114.969V114.965Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.448713
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2309 195.611V123.066C53.4704 122.963 64.5214 122.541 75.3569 121.747",
    stroke: "#382456",
    strokeWidth: 0.448713
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4381 195.612V124.18C54.2602 124.059 64.9117 123.642 75.3567 122.874",
    stroke: "#382456",
    strokeWidth: 0.448713
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6456 195.612V125.298C55.0547 125.163 65.2977 124.745 75.3567 124.009",
    stroke: "#382456",
    strokeWidth: 0.448713
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M45.853 195.612V126.416C55.8447 126.263 65.6882 125.85 75.3567 125.141",
    stroke: "#382456",
    strokeWidth: 0.448713
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M150.061 96.8716H173.505V84.2495H162.319C162.319 84.2495 163.033 90.3316 150.061 96.8716Z",
    fill: "#6B3232",
    stroke: "#382456",
    strokeWidth: 0.448713
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7043 121.272H26.0847V116.14H26.7043V121.272Z",
    fill: "#382456",
    stroke: "#382456",
    strokeWidth: 0.448713,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M27.162 122.955H25.6221V121.267H27.162V122.955Z",
    fill: "#382456",
    stroke: "#382456",
    strokeWidth: 0.448713,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3936 130.017C24.3309 130.017 22.6588 128.344 22.6588 126.282C22.6588 124.219 24.3309 122.547 26.3936 122.547C28.4563 122.547 30.1284 124.219 30.1284 126.282C30.1284 128.344 28.4563 130.017 26.3936 130.017Z",
    fill: "#FEFDE8",
    stroke: "#382456",
    strokeWidth: 0.448713,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M150.061 96.8745H162.679V205.881H150.061V96.8745Z",
    fill: "#A7584B"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M150.059 205.881H162.679V209.325H150.059V205.881Z",
    fill: "#603813",
    stroke: "#382456",
    strokeWidth: 0.448713,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M173.505 96.8711H184.327V209.324H173.505H162.679V96.8711H173.505Z",
    fill: "#603813",
    stroke: "#382456",
    strokeWidth: 0.448713,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M173.504 84.2451H184.327V96.8737H173.504H162.675V84.2451H173.504Z",
    fill: "#DA7263",
    stroke: "#382456",
    strokeWidth: 0.448713
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M336.659 114.424V116.763L315.393 119.201V114.168L336.659 114.424Z",
    fill: "#6B3232",
    stroke: "#382456",
    strokeWidth: 0.448713
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M258.93 209.32H315.396V205.878H258.93V209.32Z",
    fill: "#603813",
    stroke: "#382456",
    strokeWidth: 0.448713,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M196.927 209.32H232.155V205.877H196.927V209.32Z",
    fill: "#603813",
    stroke: "#382456",
    strokeWidth: 0.448713,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M336.629 122.286H326.602V209.324H336.629V122.286Z",
    fill: "#603813",
    stroke: "#382456",
    strokeWidth: 0.448713,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M262.974 127.493V142.952L267.821 143.319V121.281L262.974 127.493Z",
    fill: "#6B3232",
    stroke: "#382456",
    strokeWidth: 0.519438
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M268.141 209.325H262.937V144.891L268.141 140.821V209.325Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.603066
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M262.975 144.781H229.899V140.496L267.7 141.105L262.975 144.781Z",
    fill: "#6B3232",
    stroke: "#382456",
    strokeWidth: 0.603066
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M229.97 140.167V116.354C230.553 116.354 268.234 120.974 268.234 120.974V140.826L229.97 140.167Z",
    fill: "#DA7263",
    stroke: "#382456",
    strokeWidth: 0.519438
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M290.09 184.947C291.383 184.961 292.613 184.974 293.771 184.988V195.614H286.409V184.902C287.684 184.92 288.914 184.934 290.09 184.947Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.448713
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M297.452 185.029C298.848 185.042 300.082 185.051 301.133 185.06V195.614H293.771V184.988C295.095 185.002 296.325 185.015 297.452 185.024V185.029Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.448713
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M282.733 184.857C283.995 184.875 285.225 184.889 286.415 184.902V195.613H279.052V184.803C280.309 184.821 281.535 184.839 282.733 184.853V184.857Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.448713
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M275.372 184.754C276.62 184.772 277.85 184.79 279.053 184.808V195.618H271.628V184.7C272.894 184.718 274.142 184.736 275.372 184.754Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.448713
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M293.771 174.403C295.077 174.43 296.307 174.452 297.452 174.47V185.029C296.325 185.02 295.095 185.006 293.771 184.993C292.613 184.979 291.383 184.966 290.09 184.953V174.331C291.374 174.358 292.604 174.385 293.771 174.407V174.403Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.448713
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M301.132 174.524V185.06C300.082 185.051 298.847 185.042 297.451 185.029V174.47C298.798 174.493 300.032 174.511 301.132 174.524Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.448713
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M286.414 174.242C287.685 174.273 288.91 174.3 290.095 174.327V184.949C288.919 184.935 287.689 184.922 286.414 184.904C285.224 184.89 283.994 184.872 282.733 184.859V174.147C283.99 174.179 285.22 174.21 286.414 174.242Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.448713
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M275.372 184.755C274.142 184.738 272.894 184.72 271.628 184.702V173.824C272.894 173.865 274.142 173.905 275.372 173.941V184.755Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.448713
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M279.053 174.049C280.305 174.085 281.535 174.116 282.734 174.147V184.859C281.535 184.845 280.31 184.827 279.053 184.809C277.85 184.791 276.62 184.773 275.372 184.755V173.941C276.62 173.977 277.845 174.013 279.053 174.049Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.448713
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M282.734 163.491C283.986 163.54 285.212 163.585 286.415 163.625V174.242C285.221 174.215 283.995 174.184 282.734 174.148C281.535 174.117 280.305 174.081 279.052 174.049V163.338C280.3 163.392 281.526 163.441 282.734 163.491Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.448713
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M290.09 163.747C291.356 163.788 292.586 163.819 293.771 163.85V174.405C292.604 174.382 291.374 174.355 290.09 174.328C288.905 174.301 287.679 174.274 286.409 174.243V163.626C287.666 163.671 288.896 163.711 290.09 163.747Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.448713
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M297.452 163.935C298.749 163.962 299.975 163.98 301.133 163.994V174.525C300.037 174.512 298.803 174.494 297.452 174.472C296.307 174.454 295.077 174.431 293.771 174.404V163.85C295.05 163.882 296.275 163.908 297.452 163.935Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.448713
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M275.372 163.172C276.615 163.231 277.841 163.284 279.053 163.338V174.05C277.845 174.014 276.62 173.978 275.372 173.942C274.142 173.906 272.894 173.866 271.628 173.825V162.993C272.889 163.056 274.137 163.118 275.372 163.172Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.448713
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M297.451 163.937V150.312C298.749 150.339 299.974 150.357 301.132 150.37V163.995C299.979 163.982 298.749 163.964 297.451 163.937Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.448713
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M275.372 149.554V163.179C274.137 163.12 272.889 163.062 271.628 162.999V149.375C272.889 149.437 274.137 149.5 275.372 149.554Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.448713
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M279.053 149.715C280.301 149.769 281.526 149.818 282.734 149.868V163.492C281.526 163.447 280.301 163.393 279.053 163.34C277.845 163.286 276.615 163.232 275.372 163.173V149.549C276.615 149.607 277.841 149.661 279.053 149.715Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.448713
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M293.771 150.226C295.05 150.258 296.276 150.285 297.452 150.312V163.936C296.28 163.914 295.05 163.887 293.771 163.851C292.586 163.82 291.356 163.788 290.09 163.748V150.123C291.356 150.163 292.586 150.195 293.771 150.226Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.448713
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M286.414 150.002C287.671 150.047 288.901 150.087 290.095 150.123V163.748C288.901 163.712 287.671 163.671 286.414 163.627C285.211 163.586 283.985 163.541 282.733 163.492V149.867C283.985 149.917 285.211 149.961 286.414 150.002Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.448713
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M214.699 183.264C215.476 183.3 216.28 183.336 217.115 183.372V195.615H212.284V183.143C213.052 183.183 213.86 183.224 214.699 183.264Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.448713
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M209.869 183.004C210.628 183.049 211.431 183.098 212.284 183.143V195.614H207.454V182.838C208.19 182.896 208.998 182.95 209.869 183.004Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.448713
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M219.524 183.47C220.754 183.519 222.034 183.564 223.354 183.609V195.614H217.109V183.371C217.89 183.403 218.698 183.438 219.524 183.47Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.448713
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M205.039 182.621C205.726 182.693 206.534 182.765 207.455 182.837V195.613H202.853V182.285C203.293 182.401 204.034 182.514 205.039 182.621Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.448713
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M217.109 170.947C217.894 171.019 218.698 171.091 219.524 171.158V183.472C218.698 183.441 217.89 183.405 217.109 183.373C216.278 183.337 215.47 183.302 214.694 183.266V170.714C215.475 170.79 216.278 170.871 217.109 170.947Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.448713
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M212.284 170.463C213.056 170.548 213.869 170.634 214.699 170.719V183.271C213.86 183.23 213.051 183.19 212.284 183.149C211.435 183.105 210.627 183.06 209.869 183.01V170.176C210.636 170.275 211.44 170.369 212.284 170.463Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.448713
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M207.454 169.843C208.208 169.955 209.016 170.067 209.869 170.175V183.01C208.998 182.956 208.19 182.902 207.454 182.844C206.534 182.772 205.726 182.7 205.039 182.628V169.443C205.771 169.578 206.574 169.713 207.454 169.847V169.843Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.448713
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M219.524 171.159C220.764 171.262 222.039 171.365 223.354 171.464V183.613C222.034 183.568 220.755 183.518 219.524 183.474V171.159Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.448713
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M205.039 182.624C204.034 182.516 203.289 182.404 202.853 182.287V168.958C203.473 169.12 204.209 169.282 205.039 169.434V182.619V182.624Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.448713
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M205.039 156.175C205.807 156.35 206.615 156.525 207.455 156.696V169.849C206.575 169.719 205.771 169.584 205.039 169.445C204.209 169.288 203.473 169.131 202.853 168.969V155.641C203.545 155.82 204.276 156 205.039 156.175Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.448713
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M209.869 157.158C210.65 157.301 211.454 157.441 212.284 157.58V170.464C211.44 170.369 210.637 170.275 209.869 170.176C209.016 170.069 208.208 169.956 207.454 169.844V156.691C208.23 156.848 209.034 157.005 209.869 157.153V157.158Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.448713
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M214.699 157.966C215.489 158.087 216.293 158.209 217.114 158.325V170.949C216.284 170.873 215.48 170.796 214.699 170.715C213.869 170.63 213.056 170.549 212.284 170.46V157.576C213.07 157.706 213.873 157.836 214.699 157.962V157.966Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.448713
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M219.524 158.662C220.772 158.828 222.047 158.994 223.353 159.151V171.469C222.038 171.371 220.759 171.267 219.524 171.164C218.698 171.092 217.894 171.025 217.109 170.953V158.33C217.899 158.442 218.707 158.554 219.524 158.662Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.448713
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M219.524 145.038C220.772 145.204 222.047 145.37 223.354 145.527V159.152C222.047 158.995 220.772 158.829 219.524 158.663V145.038Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.448713
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M205.039 142.551V156.176C204.276 156.001 203.54 155.821 202.853 155.642V142.017C203.545 142.197 204.276 142.376 205.039 142.551Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.448713
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M217.109 144.702C217.899 144.815 218.707 144.927 219.524 145.035V158.659C218.707 158.551 217.899 158.439 217.109 158.327C216.287 158.21 215.484 158.089 214.694 157.968V144.343C215.484 144.464 216.287 144.586 217.109 144.702Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.448713
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M207.454 143.073C208.231 143.23 209.035 143.387 209.87 143.535V157.16C209.035 157.007 208.231 156.854 207.454 156.697C206.615 156.527 205.807 156.356 205.039 156.176V142.552C205.807 142.727 206.615 142.902 207.454 143.073Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.448713
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M212.284 143.957C213.07 144.087 213.873 144.217 214.699 144.343V157.967C213.873 157.842 213.07 157.711 212.284 157.581C211.458 157.442 210.65 157.303 209.869 157.159V143.535C210.65 143.678 211.454 143.817 212.284 143.957Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.448713
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M301.131 146.359V150.367C293.702 150.282 283.185 149.95 271.627 149.371V125.141C281.296 125.85 291.139 126.263 301.131 126.416V146.359Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.448713
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M304.753 123.066V195.611H301.126V126.415C291.135 126.262 281.291 125.849 271.623 125.14V121.747C282.458 122.541 293.509 122.967 304.749 123.066H304.753Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.448713
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M232.15 106.984C237.362 107.864 243.134 108.68 249.548 109.399C252.735 109.758 255.859 110.09 258.929 110.4C263.283 110.839 267.516 111.239 271.628 111.594C283.774 112.644 294.843 113.335 304.754 113.775C308.466 113.937 312.012 114.067 315.396 114.166V205.886H268.006V121.229C258.908 120.291 238.823 118.13 230.083 116.577L230.227 205.89H196.924V96.8799C203.926 100.412 214.909 104.075 232.15 106.993V106.984ZM271.628 149.37V195.611H304.754V123.066C293.514 122.963 282.463 122.541 271.628 121.747V149.37ZM202.853 142.017V195.616H223.357V115.22C216.391 113.784 209.555 112.132 202.853 110.238V142.013V142.017Z",
    fill: "#DA7263",
    stroke: "#382456",
    strokeWidth: 0.448713
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M336.631 126.181H326.602V117.925L336.631 116.683V126.181Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.448713
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M222.173 145.381C214.398 144.407 207.665 143.285 202.853 142.014V111.585C209.173 113.371 215.619 114.934 222.173 116.312V145.381Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.448713
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M222.172 114.965C222.567 115.05 222.958 115.135 223.357 115.221V195.616H222.172V116.316C215.619 114.938 209.169 113.376 202.853 111.589V110.243C209.173 112.029 215.619 113.591 222.172 114.969V114.965Z",
    fill: "#AD5750",
    stroke: "#382456",
    strokeWidth: 0.448713
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M304.754 195.611V123.066C293.514 122.963 282.463 122.541 271.628 121.747",
    stroke: "#382456",
    strokeWidth: 0.448713
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M303.546 195.612V124.18C292.724 124.059 282.073 123.642 271.628 122.874",
    stroke: "#382456",
    strokeWidth: 0.448713
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M302.339 195.612V125.298C291.93 125.163 281.687 124.745 271.628 124.009",
    stroke: "#382456",
    strokeWidth: 0.448713
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M301.132 195.612V126.416C291.14 126.263 281.296 125.85 271.628 125.141",
    stroke: "#382456",
    strokeWidth: 0.448713
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M196.924 96.8716H173.48V84.2495H184.666C184.666 84.2495 183.952 90.3316 196.924 96.8716Z",
    fill: "#6B3232",
    stroke: "#382456",
    strokeWidth: 0.448713
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M319.841 121.272H320.461V116.14H319.841V121.272Z",
    fill: "#382456",
    stroke: "#382456",
    strokeWidth: 0.448713,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M319.384 122.955H320.924V121.267H319.384V122.955Z",
    fill: "#382456",
    stroke: "#382456",
    strokeWidth: 0.448713,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M320.152 130.017C322.215 130.017 323.887 128.344 323.887 126.282C323.887 124.219 322.215 122.547 320.152 122.547C318.089 122.547 316.417 124.219 316.417 126.282C316.417 128.344 318.089 130.017 320.152 130.017Z",
    fill: "#FEFDE8",
    stroke: "#382456",
    strokeWidth: 0.448713,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M196.924 96.875H184.307V205.881H196.924V96.875Z",
    fill: "#A7584B"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M196.927 205.881H184.306V209.325H196.927V205.881Z",
    fill: "#603813",
    stroke: "#382456",
    strokeWidth: 0.448713,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M173.48 96.8711H162.658V209.324H173.48H184.307V96.8711H173.48Z",
    fill: "#603813",
    stroke: "#382456",
    strokeWidth: 0.448713,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M173.482 84.2451H162.658V96.8737H173.482H184.31V84.2451H173.482Z",
    fill: "#DA7263",
    stroke: "#382456",
    strokeWidth: 0.448713
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.209 17H160.279C164.56 26.0565 168.848 35.1059 173.15 44.1553C177.458 35.1059 181.767 26.0565 186.055 17H186.126C192.508 33.0611 198.904 49.1151 205.321 65.162C206.857 65.1832 208.385 65.1903 209.92 65.1832V69.195H183.409V65.1832C185.164 65.1832 186.911 65.1832 188.666 65.162C186.642 60.1102 184.626 55.0513 182.616 49.9854C179.454 56.3744 176.305 62.7776 173.185 69.1879H173.114C169.994 62.7847 166.874 56.3815 163.753 49.9854C161.695 55.0372 159.657 60.0961 157.633 65.162C159.388 65.1832 161.136 65.1903 162.89 65.1832V69.195H136.379V65.1832C137.914 65.1832 139.443 65.1832 140.978 65.162C147.402 49.1151 153.813 33.0611 160.209 17Z",
    fill: "#F00C50",
    stroke: "#382456",
    strokeWidth: 0.527632,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M147.244 73.6734V83.2982L146.373 83.9896L147.244 84.3038L148.195 83.7382H148.227V83.7202L152.061 81.4442V70.724L151.14 70.4727L147.239 73.6779L147.244 73.6734ZM151.033 81.0267L148.231 82.7101V74.0819L151.033 72.3806V81.0312V81.0267Z",
    fill: "#6B3232",
    stroke: "#6B3232",
    strokeWidth: 0.448713,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M146.373 73.4141V83.9861L147.316 83.4205H147.347V83.4025L151.14 81.131V70.4692L146.373 73.4141ZM150.121 80.7225L147.347 82.4015V73.8182L150.121 72.1213V80.727V80.7225Z",
    fill: "#AD5750",
    stroke: "#AD5750",
    strokeWidth: 0.448713,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M126.48 81.7926V88.8772L126.004 91.5754L126.48 92.0154L127.449 91.7371V89.6359L132.9 88.3744V79.8038L132.379 79.3862L126.48 81.7971V81.7926ZM131.858 87.5932L127.454 88.6437V82.484L131.858 81.1461V87.5932Z",
    fill: "#6B3232",
    stroke: "#6B3232",
    strokeWidth: 0.448713,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M126.004 81.3852V91.5765L126.964 91.2981V89.2015L132.379 87.9265V79.3828L126.004 81.3852ZM131.342 87.1543L126.964 88.2138V82.0721L131.342 80.7297V87.1543Z",
    fill: "#AD5750",
    stroke: "#AD5750",
    strokeWidth: 0.448713,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M100.275 87.0452V88.0462L99.709 96.0371L100.275 96.4501H101.276V87.9116L103.525 87.6108L102.959 95.5343L103.525 95.9473H104.526V87.4761L106.771 87.1753L106.209 95.0315L106.771 95.4445H107.776V87.0407V86.0351L107.215 85.6221L100.275 87.0452Z",
    fill: "#6B3232",
    stroke: "#6B3232",
    strokeWidth: 0.448713,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M99.709 86.6277V87.6288V96.0371H100.715V87.4941L102.959 87.1933V95.5343H103.965V87.0586L106.209 86.7578V95.0315H107.215V86.6232V85.6221L99.709 86.6277Z",
    fill: "#AD5750",
    stroke: "#AD5750",
    strokeWidth: 0.448713,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M77.9361 90.5009V89.4998L77.3211 89.2529L69.9184 90.2091V91.2102V94.411V95.4121L69.3079 99.3716L69.9184 99.6141L77.9361 98.9048V97.9037L77.3211 97.6568L70.924 98.5681V95.3673L77.9361 94.7028V93.7018L77.3211 93.4548L70.924 94.3662V91.1653L77.9361 90.5009Z",
    fill: "#6B3232",
    stroke: "#6B3232",
    strokeWidth: 0.448713,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M77.3211 90.254V89.2529L69.3079 89.9622V90.9633V94.1641V95.1652V98.3661V99.3716L77.3211 98.6623V97.6568L70.309 98.3212V95.1203L77.3211 94.4559V93.4548L70.309 94.1193V90.9184L77.3211 90.254Z",
    fill: "#AD5750",
    stroke: "#AD5750",
    strokeWidth: 0.448713,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4148 91.6054L40.8728 99.4436L37.2275 91.9287L36.2444 91.9736L36.2534 102.151L37.2545 102.11L37.2365 94.0206L40.379 100.535L41.3801 100.494L44.4372 93.7019L44.5405 101.809L45.5461 101.769L45.4024 91.5605L44.4148 91.6054Z",
    fill: "#6B3232",
    stroke: "#6B3232",
    strokeWidth: 0.448713,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7914 91.6318L40.2449 99.47L36.6131 91.955L35.6255 91.9999V102.173L36.6266 102.132L36.6131 94.0515L39.7556 100.561L40.7522 100.52L43.8183 93.7283L43.9126 101.836L44.9182 101.795L44.7835 91.5869L43.7914 91.6318Z",
    fill: "#AD5750",
    stroke: "#AD5750",
    strokeWidth: 0.448713,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M318.541 92.9435L317.903 92.9166L310.101 92.0322L309.518 92.535V102.079L310.519 102.124L317.903 102.461L318.541 102.488L319.493 102.003L318.909 92.9615L318.541 92.9435ZM310.519 101.123V93.5855L317.903 93.9222V101.46L310.519 101.123Z",
    fill: "#6B3232",
    stroke: "#6B3232",
    strokeWidth: 0.448713,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M319.124 92.4407L318.487 92.4138L311.102 92.0771L310.101 92.0322V101.576L311.102 101.621L318.487 101.958L319.124 101.985L319.493 102.003V92.4587L319.124 92.4407ZM311.102 100.62V93.0827L318.487 93.4194V100.957L311.102 100.62Z",
    fill: "#AD5750",
    stroke: "#AD5750",
    strokeWidth: 0.448713,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M277.194 90.3594L276.714 89.7578L276.193 90.2516V100.105L277.194 100.146L277.715 99.6521L277.194 98.1392L284.74 98.9652L285.261 98.4714L284.74 97.9282V91.1854L277.194 90.3594ZM283.735 97.8205L277.189 97.1067V91.3964L283.735 92.1102V97.8205Z",
    fill: "#6B3232",
    stroke: "#6B3232",
    strokeWidth: 0.448713,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M276.714 89.7578V99.6117L277.715 99.6521V97.6454L285.261 98.4714V90.6916L276.714 89.7578ZM284.26 97.3266L277.715 96.6129V90.9026L284.26 91.6164V97.3266Z",
    fill: "#AD5750",
    stroke: "#AD5750",
    strokeWidth: 0.448713,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M245.275 86.799V87.8226V96.5368L246.294 96.7164L246.747 96.263L246.294 87.9618L248.62 88.2715V97.098L249.625 97.2731L250.074 96.8242L249.625 88.4062L251.915 88.7115V97.6503L252.903 97.8209L253.343 97.3764L252.903 88.8462V87.8405L245.733 86.3545L245.275 86.799Z",
    fill: "#6B3232",
    stroke: "#6B3232",
    strokeWidth: 0.448713,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M245.733 86.3545V87.378V96.0826L246.747 96.2622V87.5172L249.073 87.8314V96.6483L250.074 96.8234V87.9661L252.355 88.2759V97.2004L253.342 97.3755V88.4106V87.405L245.733 86.3545Z",
    fill: "#AD5750",
    stroke: "#AD5750",
    strokeWidth: 0.448713,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M224.243 83.3203L225.001 82.9207L224.243 82.3146L218.756 80.4155L218.002 80.8106V81.8163V85.5561V86.5573V90.3016V91.3027L224.243 92.8068L225.001 92.4117L224.243 91.8056L219.003 90.544V86.7997L224.243 88.0613L225.001 87.6662L224.243 87.0601L219.003 85.7985V82.0542L224.243 83.3203Z",
    fill: "#6B3232",
    stroke: "#6B3232",
    strokeWidth: 0.448713,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M225.001 82.9207V81.9195L218.756 80.4155V81.4167V85.1565V86.1622V89.902V90.9077L225.001 92.4117V91.406L219.758 90.1444V86.4046L225.001 87.6662V86.6605L219.758 85.399V81.6591L225.001 82.9207Z",
    fill: "#AD5750",
    stroke: "#AD5750",
    strokeWidth: 0.448713,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M200.564 74.4336L198.863 81.7016L197.296 72.1576L197.116 71.3989L196.295 71.574V82.6129L197.296 83.1426L198.118 82.9675L197.296 76.539L198.427 83.6903L199.15 83.9731L199.972 83.8025L200.564 77.8364V85.1223L201.565 85.4141L202.387 85.239L201.565 74.8466L201.386 74.263L200.564 74.4336Z",
    fill: "#6B3232",
    stroke: "#6B3232",
    strokeWidth: 0.448713,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M201.385 74.263L199.684 81.5265L198.117 71.9825L197.116 71.3989V82.4378L198.117 82.9675V76.3684L199.249 83.5197L199.971 83.8025L201.385 77.6613V84.9473L202.387 85.239V74.6715L201.385 74.263Z",
    fill: "#AD5750",
    stroke: "#AD5750",
    strokeWidth: 0.448713,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M86.1423 137.833V131.589H89.0502C89.7757 131.589 90.3406 131.729 90.745 132.008C91.1494 132.288 91.3516 132.686 91.3516 133.204C91.3516 133.715 91.1613 134.113 90.7807 134.399C90.4001 134.678 89.8946 134.818 89.2643 134.818L89.4338 134.443C90.1355 134.443 90.6796 134.583 91.0661 134.863C91.4526 135.142 91.6459 135.547 91.6459 136.076C91.6459 136.623 91.4378 137.054 91.0215 137.369C90.6112 137.678 90.0106 137.833 89.2197 137.833H86.1423ZM87.5784 136.763H89.1662C89.4992 136.763 89.7519 136.697 89.9244 136.566C90.0968 136.436 90.183 136.233 90.183 135.96C90.183 135.698 90.0968 135.505 89.9244 135.38C89.7519 135.249 89.4992 135.184 89.1662 135.184H87.5784V136.763ZM87.5784 134.176H88.9253C89.2405 134.176 89.4784 134.113 89.6389 133.989C89.7995 133.858 89.8798 133.667 89.8798 133.418C89.8798 133.168 89.7995 132.981 89.6389 132.856C89.4784 132.725 89.2405 132.659 88.9253 132.659H87.5784V134.176ZM92.0394 137.833L94.1891 135.014L94.1624 135.781L92.1019 133.034H93.6628L94.9651 134.827L94.3764 134.845L95.7233 133.034H97.204L95.1346 135.755V135.005L97.2754 137.833H95.6966L94.3318 135.924L94.9116 136.004L93.5558 137.833H92.0394ZM100.06 137.904C99.5487 137.904 99.0938 137.797 98.6954 137.583C98.3029 137.369 97.9907 137.078 97.7588 136.709C97.5328 136.334 97.4199 135.909 97.4199 135.434C97.4199 134.952 97.5328 134.527 97.7588 134.158C97.9907 133.783 98.3029 133.492 98.6954 133.284C99.0938 133.07 99.5487 132.963 100.06 132.963C100.566 132.963 101.018 133.07 101.416 133.284C101.814 133.492 102.127 133.78 102.353 134.149C102.579 134.518 102.692 134.946 102.692 135.434C102.692 135.909 102.579 136.334 102.353 136.709C102.127 137.078 101.814 137.369 101.416 137.583C101.018 137.797 100.566 137.904 100.06 137.904ZM100.06 136.763C100.292 136.763 100.5 136.709 100.685 136.602C100.869 136.495 101.015 136.343 101.122 136.147C101.229 135.945 101.282 135.707 101.282 135.434C101.282 135.154 101.229 134.916 101.122 134.72C101.015 134.524 100.869 134.372 100.685 134.265C100.5 134.158 100.292 134.104 100.06 134.104C99.8282 134.104 99.6201 134.158 99.4357 134.265C99.2514 134.372 99.1027 134.524 98.9898 134.72C98.8827 134.916 98.8292 135.154 98.8292 135.434C98.8292 135.707 98.8827 135.945 98.9898 136.147C99.1027 136.343 99.2514 136.495 99.4357 136.602C99.6201 136.709 99.8282 136.763 100.06 136.763ZM106.879 137.209V134.176H105.309L105.283 134.791C105.271 135.047 105.256 135.291 105.238 135.523C105.22 135.755 105.184 135.966 105.131 136.156C105.083 136.34 105.012 136.498 104.917 136.629C104.822 136.754 104.694 136.84 104.533 136.888L103.16 136.691C103.332 136.691 103.472 136.641 103.579 136.54C103.686 136.433 103.769 136.287 103.829 136.103C103.888 135.912 103.933 135.698 103.962 135.46C103.992 135.217 104.013 134.961 104.025 134.693L104.087 133.034H108.271V137.209H106.879ZM102.999 138.868V136.691H108.958V138.868H107.664V137.833H104.292V138.868H102.999Z",
    fill: "white"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M232.804 137.833V131.589H235.712C236.438 131.589 237.003 131.729 237.407 132.008C237.811 132.288 238.014 132.686 238.014 133.204C238.014 133.715 237.823 134.113 237.443 134.399C237.062 134.678 236.557 134.818 235.926 134.818L236.096 134.443C236.798 134.443 237.342 134.583 237.728 134.863C238.115 135.142 238.308 135.547 238.308 136.076C238.308 136.623 238.1 137.054 237.684 137.369C237.273 137.678 236.673 137.833 235.882 137.833H232.804ZM234.24 136.763H235.828C236.161 136.763 236.414 136.697 236.586 136.566C236.759 136.436 236.845 136.233 236.845 135.96C236.845 135.698 236.759 135.505 236.586 135.38C236.414 135.249 236.161 135.184 235.828 135.184H234.24V136.763ZM234.24 134.176H235.587C235.903 134.176 236.14 134.113 236.301 133.989C236.462 133.858 236.542 133.667 236.542 133.418C236.542 133.168 236.462 132.981 236.301 132.856C236.14 132.725 235.903 132.659 235.587 132.659H234.24V134.176ZM244.285 137.833V133.034H245.668V137.833H244.285ZM241.868 134.568C242.498 134.574 242.971 134.717 243.286 134.996C243.607 135.27 243.768 135.66 243.768 136.165C243.768 136.694 243.587 137.108 243.224 137.405C242.861 137.696 242.347 137.842 241.681 137.842L239.344 137.833V133.034H240.726V134.568H241.868ZM241.556 136.852C241.823 136.858 242.029 136.801 242.171 136.682C242.314 136.563 242.385 136.385 242.385 136.147C242.385 135.909 242.314 135.74 242.171 135.639C242.029 135.532 241.823 135.475 241.556 135.469L240.726 135.46V136.852H241.556ZM246.367 137.833L248.517 135.014L248.49 135.781L246.429 133.034H247.99L249.293 134.827L248.704 134.845L250.051 133.034H251.532L249.462 135.755V135.005L251.603 137.833H250.024L248.659 135.924L249.239 136.004L247.883 137.833H246.367ZM254.388 137.904C253.876 137.904 253.421 137.797 253.023 137.583C252.63 137.369 252.318 137.078 252.086 136.709C251.86 136.334 251.747 135.909 251.747 135.434C251.747 134.952 251.86 134.527 252.086 134.158C252.318 133.783 252.63 133.492 253.023 133.284C253.421 133.07 253.876 132.963 254.388 132.963C254.893 132.963 255.345 133.07 255.744 133.284C256.142 133.492 256.454 133.78 256.68 134.149C256.906 134.518 257.019 134.946 257.019 135.434C257.019 135.909 256.906 136.334 256.68 136.709C256.454 137.078 256.142 137.369 255.744 137.583C255.345 137.797 254.893 137.904 254.388 137.904ZM254.388 136.763C254.62 136.763 254.828 136.709 255.012 136.602C255.196 136.495 255.342 136.343 255.449 136.147C255.556 135.945 255.61 135.707 255.61 135.434C255.61 135.154 255.556 134.916 255.449 134.72C255.342 134.524 255.196 134.372 255.012 134.265C254.828 134.158 254.62 134.104 254.388 134.104C254.156 134.104 253.948 134.158 253.763 134.265C253.579 134.372 253.43 134.524 253.317 134.72C253.21 134.916 253.157 135.154 253.157 135.434C253.157 135.707 253.21 135.945 253.317 136.147C253.43 136.343 253.579 136.495 253.763 136.602C253.948 136.709 254.156 136.763 254.388 136.763ZM261.207 137.209V134.176H259.637L259.61 134.791C259.598 135.047 259.583 135.291 259.566 135.523C259.548 135.755 259.512 135.966 259.459 136.156C259.411 136.34 259.34 136.498 259.244 136.629C259.149 136.754 259.021 136.84 258.861 136.888L257.487 136.691C257.66 136.691 257.799 136.641 257.906 136.54C258.013 136.433 258.097 136.287 258.156 136.103C258.216 135.912 258.26 135.698 258.29 135.46C258.32 135.217 258.341 134.961 258.352 134.693L258.415 133.034H262.598V137.209H261.207ZM257.327 138.868V136.691H263.285V138.868H261.992V137.833H258.62V138.868H257.327Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetroBuilding);
export default __webpack_public_path__ + "static/media/MetroBuilding.50e15812b55c2c3d1b12.svg";
export { ForwardRef as ReactComponent };